import React, { useRef, useState, useEffect } from "react"
import NotificationAlert from 'react-notification-alert';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { ValidateFormUser } from 'Validate/ValidateForm'
import moment from 'moment'
import {
    FormGroup,
    Label,
    Input,
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Row,
    Col,
    Table,
    Div,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from "reactstrap";

import UserService from '../../services/user.service.v3';
import ToolService from '../../services/tool.service';
import OrderService from '../../services/order.service';

import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Select from 'react-select';
import './CSS.css'

Date.prototype.addDays = function (days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

function OrderCreate(props) {
    const [account, setAccount] = useState('')
    const [email, setEmail] = useState('')
    const [fullName, setFullName] = useState('')
    const [phone, setPhone] = useState('')
    const [language, setLanguage] = useState('Vietnamese')
    const [drive, setDrive] = useState(1)
    const [password, setPassword] = useState(Math.random().toString(36).slice(-8))
    const [expired, setExpired] = useState(moment(new Date()).format('YYYY-MM-DD'))
    const [activeCalendar, setActiveCalendar] = useState(false)
    const [calendar, setCalendar] = useState(new Date());
    const [message, setMessage] = useState('')
    const [orderId, setOrderId] = useState('')
    const [qrCodeUrl, setQrCodeUrl] = useState('')

    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    const notificationAlertRef = useRef(null);

    // Dropdown cho Tool selector
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () => setDropdownOpen(prevState => !prevState);
    const [selectedTool, setSelectedTool] = useState("dhbreupyoutube");
    const [toolName, setToolName] = useState("DHB Reup Youtube");
    const [toolsList, setToolsList] = useState([]);

    const [showload, setShowload] = useState(false)
    const [showloadPending, setShowloadPending] = useState(false)
    const [showloadSendMail, setShowloadSendMail] = useState(false)

    const [showCopy, setShowCopy] = useState(false)
    const [showCopyEmail, setShowCopyEmail] = useState(false)

    const [optionsThoiHan, setOptionsThoiHan] = useState([])
    const [thoiHan, setThoiHan] = useState(null)

    const [optionLoai, setOptionLoai] = useState([])
    const [loai, setLoai] = useState(null)

    const [paymentMethod, setPaymentMethod] = useState("Chuyển khoản")
    const [price, setPrice] = useState('300000')

    const [packages, setPackages] = useState([])
    const [selectedPackage, setSelectedPackage] = useState(null)

    const [variations, setVariations] = useState([]);
    const [selectedVariation, setSelectedVariation] = useState(null);

    // Giỏ hàng
    const [cart, setCart] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);

    const [showProductModal, setShowProductModal] = useState(false);
    const toggleProductModal = () => setShowProductModal(!showProductModal);

    const PATH = selectedTool
    const back = () => props.changePage('', 'add', null);

    useEffect(() => {
        loadTools();
    }, [])

    useEffect(() => {
        if (selectedTool) {
            loadToolAttributes();
            loadVariations();
        }
    }, [selectedTool])

    function loadTools() {
        ToolService.getTool().then((res) => {
            if (res.data && Array.isArray(res.data)) {
                setToolsList(res.data);
                // Nếu có dữ liệu và chưa chọn tool, thì chọn tool đầu tiên trong danh sách
                if (res.data.length > 0 && !selectedTool) {
                    setSelectedTool(res.data[0].id);
                    setToolName(res.data[0].name);
                }
            }
        }).catch(error => {
            console.error("Error loading tools:", error);
            Swal.fire({
                icon: 'error',
                title: 'Lỗi khi tải danh sách công cụ',
                text: 'Không thể tải danh sách công cụ từ máy chủ',
                showConfirmButton: true
            });
        });
    }

    function loadVariations() {
        ToolService.getVariations(selectedTool).then((result) => {
            if (result.data && Array.isArray(result.data)) {
                setVariations(result.data);

                // Khởi tạo giá trị mặc định cho variation
                if (result.data.length > 0) {
                    const defaultVariation = result.data[0];
                    setSelectedVariation(defaultVariation);
                    setPrice(defaultVariation.price || '300000');

                    // Cập nhật gói dịch vụ từ thuộc tính của variation
                    defaultVariation.attributes.forEach(attr => {
                        if (attr.name.toLowerCase().includes('thời hạn')) {
                            // Tìm gói dịch vụ phù hợp với thuộc tính
                            const matchingPackage = packages.find(pkg =>
                                pkg.label.toLowerCase().includes(attr.option.toLowerCase())
                            );

                            if (matchingPackage) {
                                setSelectedPackage(matchingPackage);
                            }
                        }
                    });
                }
            }
        }).catch(error => {
            console.error("Error loading variations:", error);
            Swal.fire({
                icon: 'error',
                title: 'Lỗi khi tải dữ liệu biến thể',
                text: 'Không thể tải thông tin biến thể sản phẩm',
                showConfirmButton: true
            });
        });
    }

    function loadToolAttributes() {
        if (!selectedTool) return;
        ToolService.getAttribute(PATH).then((result) => {
            // Khởi tạo các gói dịch vụ từ API
            if (result.data && result.data.length > 0) {
                let packageOptions = [];
                result.data.forEach(item => {
                    if (item.name.toLowerCase() == "thời hạn") {
                        setOptionsThoiHan(item.options)

                        // Tạo các gói từ tùy chọn thời hạn
                        item.options.forEach(option => {
                            packageOptions.push({
                                value: option.value,
                                label: option.value,
                                exp: option.exp,
                                // Giá sẽ được cập nhật từ variations
                                price: option.price || '300000'
                            });
                        });

                        if (packageOptions.length > 0) {
                            setPackages(packageOptions);
                            setSelectedPackage(packageOptions[0]);
                            setThoiHan(item.options[0]);
                            setExpired(moment(new Date().addDays(item.options[0].exp)).format('YYYY-MM-DD'));

                            if (item.options[0].value.includes("10")) {
                                setDrive(10);
                            }
                        }
                    } else if (item.name.toLowerCase() == "loại") {
                        setOptionLoai(item.options)
                        setLoai(item.options[0])
                    }
                });
            }
        }).catch(error => {
            console.error("Error loading tool attributes:", error);
            Swal.fire({
                icon: 'error',
                title: 'Lỗi khi tải dữ liệu',
                text: 'Không thể tải thông tin gói dịch vụ',
                showConfirmButton: true
            });
        });
    }

    function optionsMaMay() {
        var opt = []
        for (var i = 1; i < 16; i++) {
            opt.push({ value: i, label: i })
        }
        return opt
    }

    const optionsLanguage = [
        { value: 'Vietnamese', label: 'Vietnamese' },
        { value: 'English', label: 'English' },
    ];

    const optionsPaymentMethod = [
        { value: 'Chuyển khoản', label: 'Chuyển khoản' },
        { value: 'Tiền mặt', label: 'Tiền mặt' },
        { value: 'Paypal', label: 'Paypal' },
    ];

    const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger'
        },
        buttonsStyling: false
    })

    function selectACalendar(value) {
        setCalendar(value)
        const date = new Date(value)
        const newDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
        setExpired(newDate)
        setActiveCalendar(false)
    }

    function addToCart() {
        const newItem = {
            id: Date.now(), // ID tạm thời cho item trong giỏ hàng
            toolId: selectedTool,
            toolName: toolName,
            packageName: selectedPackage ? selectedPackage.label : 'Gói cơ bản',
            price: price,
            account: account,
            password: password,
            language: language,
            drive: drive,
            expired: moment(expired).format('YYYY-MM-DD'),
            thoihan: selectedPackage ? selectedPackage.value : (thoiHan ? thoiHan.value : ''),
            loai: loai ? loai.value : ''
        };

        const updatedCart = [...cart, newItem];
        setCart(updatedCart);

        // Tính tổng giá tiền
        const newTotalPrice = updatedCart.reduce((sum, item) => sum + parseInt(item.price), 0);
        setTotalPrice(newTotalPrice);

        showNotification("Đã thêm sản phẩm vào giỏ hàng", "success");
    }

    function showNotification(message, type = "success") {
        const options = {
            place: 'tc',
            message: (
                <div>
                    <div>
                        {message}
                    </div>
                </div>
            ),
            type: type,
            icon: "nc-icon nc-check-2",
            autoDismiss: 3
        };

        notificationAlertRef.current.notificationAlert(options);
    }

    function removeFromCart(itemId) {
        const updatedCart = cart.filter(item => item.id !== itemId);
        setCart(updatedCart);

        // Cập nhật tổng giá tiền
        const newTotalPrice = updatedCart.reduce((sum, item) => sum + parseInt(item.price), 0);
        setTotalPrice(newTotalPrice);
    }

    function createOrder(status = 'completed') {
        if (cart.length === 0) {
            showNotification("Giỏ hàng trống. Vui lòng thêm sản phẩm trước khi đặt hàng.", "danger");
            return;
        }

        if (!fullName || !email || !phone) {
            showNotification("Vui lòng nhập đầy đủ thông tin khách hàng", "warning");
            return;
        }

        if (status === 'completed') {
            setShowload(true);
        } else {
            setShowloadPending(true);
        }

        const products = cart.map(item => ({
            name: `${item.toolName} - ${item.packageName}`,
            quantity: 1,
            price: item.price,
            tool: item.toolId,
            info: {
                username: item.account,
                password: item.password,
                language: item.language,
                drive: item.drive,
                expired: item.expired,
                thoihan: item.thoihan,
                loai: item.loai
            }
        }));

        const orderData = {
            fullname: fullName,
            email: email,
            phone: phone,
            payment_method: paymentMethod,
            status: status,
            products: products,
            total: totalPrice.toString()
        }

        OrderService.createOrder(orderData)
            .then((result) => {
                setShowload(false);
                setShowloadPending(false);

                if (result.data.success) {
                    const generatedOrderId = result.data.order.id;
                    setOrderId(generatedOrderId);

                    // Tạo URL QR code với giá tiền và ID đơn hàng
                    const qrUrl = `https://img.vietqr.io/image/sacombank-050072093434-compact2.jpg?amount=${totalPrice}&addInfo=${generatedOrderId}&accountName=DO%20HUU%20BEN`;
                    setQrCodeUrl(qrUrl);

                    const statusText = status === 'completed' ? 'hoàn thành' : 'chờ thanh toán';

                    // Tạo thông tin sản phẩm từ giỏ hàng
                    let productInfo = '';
                    cart.forEach((item, index) => {
                        productInfo += `\nSản phẩm ${index + 1}: ${item.toolName} - ${item.packageName} - ${parseInt(item.price).toLocaleString('vi-VN')} VNĐ`;
                    });

                    setMessage(`Đã tạo đơn hàng thành công\nID đơn hàng: ${generatedOrderId}\nHọ tên: ${fullName}\nEmail: ${email}\nSố điện thoại: ${phone}${productInfo}\nTổng tiền: ${totalPrice.toLocaleString('vi-VN')} VNĐ\nPhương thức thanh toán: ${paymentMethod}\nTrạng thái: ${statusText}`)

                    Swal.fire({
                        icon: 'success',
                        title: `Tạo đơn hàng ${statusText} thành công`,
                        showConfirmButton: false,
                        timer: 1500
                    }).then(res => {
                        setModal(true);
                        // Xóa giỏ hàng sau khi đặt hàng thành công
                        setCart([]);
                        setTotalPrice(0);
                    })
                } else {
                    swalWithBootstrapButtons.fire(
                        'Thất bại !',
                        result.data.message,
                        'error'
                    )
                }

            }, error => {
                setShowload(false);
                setShowloadPending(false);
                showNotification("Lỗi kết nối: " + (error.message || "Không thể tạo đơn hàng"), "danger");
            })
    }

    function copyToClipboard() {
        setShowCopy(true)
        var textField = document.createElement('textarea')
        textField.value = message
        document.body.appendChild(textField)
        textField.select()
        document.execCommand('copy')
        textField.remove()
    }

    function copyEmailToClipboard() {
        setShowCopyEmail(true)
        var textField = document.createElement('textarea')
        textField.value = email
        document.body.appendChild(textField)
        textField.select()
        document.execCommand('copy')
        textField.remove()
    }

    const style = {
        maxHeight: '230px',
        minHeight: '230px',
        resize: 'none',
        padding: '9px',
        boxSizing: 'border-box',
        fontSize: '15px',
        marginTop: '25px'
    };

    return (
        <div className="content">
            <NotificationAlert ref={notificationAlertRef} />
            <Row>
                <Col lg="8" md="8" sm="8">
                    <Card style={{ padding: '15px' }} >
                        <CardHeader>
                            <div className="d-flex justify-content-between align-items-center">
                                <Label style={{ fontSize: '24px', color: 'DimGray', fontWeight: 'bold' }}><i className="fas fa-plus-circle" style={{ marginRight: '8px' }}></i>Tạo đơn hàng mới</Label>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col lg="12" md="12" sm="12">
                                    <FormGroup>
                                        <div className="form-row">
                                            <div className="form-group col-md-4">
                                                <Label for="fullname">Họ tên</Label>
                                                <Input
                                                    value={fullName}
                                                    id="fullname"
                                                    onChange={(e) => setFullName(e.target.value)}
                                                    placeholder="Họ và tên"
                                                />
                                            </div>
                                            <div className="form-group col-md-4">
                                                <Label for="facebook">Facebook URL</Label>
                                                <Input
                                                    id="facebook"
                                                    onChange={(e) => { }}
                                                    placeholder="Đường dẫn Facebook"
                                                />
                                            </div>
                                            <div className="form-group col-md-4">
                                                <Label for="phonenumber">Số điện thoại</Label>
                                                <Input
                                                    value={phone}
                                                    id="phonenumber"
                                                    onChange={(e) => setPhone(e.target.value)}
                                                    placeholder="Số điện thoại"
                                                />
                                            </div>
                                        </div>

                                        <div className="form-row" style={{ marginTop: "20px" }}>
                                            <div className="form-group col-md-4">
                                                <Label for="email">Email</Label>
                                                <Input
                                                    value={email}
                                                    id="email"
                                                    onChange={(e) => {
                                                        setEmail(e.target.value)
                                                        var user = e.target.value
                                                        if (user.includes("@")) {
                                                            var arr = user.split('@')
                                                            setAccount(arr[0])
                                                        } else {
                                                            setAccount(user)
                                                        }
                                                    }}
                                                    placeholder="Địa chỉ email"
                                                />
                                            </div>
                                            <div className="form-group col-md-4">
                                                <Label for="account">Tài khoản</Label>
                                                <Input
                                                    value={account}
                                                    id="account"
                                                    onChange={(e) => setAccount(e.target.value)}
                                                    placeholder="Tên tài khoản"
                                                />
                                            </div>
                                            <div className="form-group col-md-4">
                                                <Label for="password">Mật khẩu</Label>
                                                <div className="input-group">
                                                    <Input
                                                        value={password}
                                                        id="password"
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        placeholder="Mật khẩu"
                                                    />
                                                    <div className="input-group-append">
                                                        <Button
                                                            className="btn btn-info"
                                                            onClick={() => setPassword(Math.random().toString(36).slice(-8))}
                                                            style={{ whiteSpace: 'nowrap', height: '100%' }}
                                                        >
                                                            Ngẫu nhiên
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                    <Card style={{ padding: '15px' }} >
                        <CardHeader className="d-flex justify-content-between align-items-center">
                            <Label style={{ fontSize: '24px', color: 'DimGray', fontWeight: 'bold' }}><i className="fas fa-box-open" style={{ marginRight: '8px' }}></i>Danh sách sản phẩm</Label>
                            <Button color="success" onClick={toggleProductModal}>
                                <i className="nc-icon nc-simple-add mr-1"></i> Thêm sản phẩm
                            </Button>
                        </CardHeader>

                        <CardBody style={{ padding: '15px 0' }}>
                            {cart.length > 0 ? (
                                <>
                                    <Table className="table-hover table-striped" style={{ fontSize: '0.95rem', margin: '0' }}>
                                        <thead className="text-primary">
                                            <tr>
                                                <th>Sản phẩm</th>
                                                <th>Gói dịch vụ</th>
                                                <th>Giá</th>
                                                <th style={{ width: '50px' }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cart.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>{item.toolName}</td>
                                                    <td>{item.packageName}</td>
                                                    <td>{parseInt(item.price).toLocaleString('vi-VN')} đ</td>
                                                    <td>
                                                        <Button
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => removeFromCart(item.id)}
                                                        >
                                                            <i className="nc-icon nc-simple-remove"></i>
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                    <h5 className="mb-0 mr-3">Tổng tiền: <span className="text-success">{totalPrice.toLocaleString('vi-VN')} VNĐ</span></h5>
                                </>
                            ) : (
                                <div className="text-center py-4" style={{ backgroundColor: "#f8f9fa", borderRadius: "4px", border: "1px dashed #ddd" }}>
                                    <i className="nc-icon nc-cart-simple" style={{ fontSize: '3rem', color: '#ddd' }}></i>
                                    <p className="mt-2 mb-1">Giỏ hàng trống</p>
                                    <p className="text-muted small mb-3">Hãy nhấn nút "Thêm sản phẩm" để chọn sản phẩm</p>
                                    <Button color="success" onClick={toggleProductModal}>
                                        <i className="nc-icon nc-simple-add mr-1"></i> Thêm sản phẩm
                                    </Button>
                                </div>
                            )}
                        </CardBody>

                        {cart.length > 0 && (
                            <CardFooter className="d-flex justify-content-between align-items-center" style={{ backgroundColor: '#f8f9fa', padding: '15px' }}>
                                <div className="d-flex align-items-center">
                                    <Label for="paymentMethod" className="mb-0 mr-2">Phương thức thanh toán:</Label>
                                    <div style={{ width: "200px" }}>
                                        <Select
                                            className="dropdown-select"
                                            isSearchable={false}
                                            placeholder={paymentMethod}
                                            value={paymentMethod}
                                            onChange={(e) => setPaymentMethod(e.value)}
                                            options={optionsPaymentMethod}
                                        />
                                    </div>
                                </div>
                                <div className="d-flex align-items-center">
                                    <Button
                                        className='btn btn-primary'
                                        style={{ marginRight: "10px" }}
                                        onClick={() => createOrder('completed')}
                                    >
                                        Tạo đơn hàng {showload ? <span className="spinner-border spinner-border-sm"></span> : null}
                                    </Button>
                                    <Button
                                        className='btn btn-warning'
                                        style={{ color: "white" }}
                                        onClick={() => createOrder('pending')}
                                    >
                                        Chờ thanh toán {showloadPending ? <span className="spinner-border spinner-border-sm"></span> : null}
                                    </Button>
                                </div>
                            </CardFooter>
                        )}
                    </Card>
                </Col>

                <Col lg="4" md="4" sm="4">
                    <Card style={{ padding: '15px' }} >
                        <CardHeader>
                            <Label style={{ fontSize: '24px', color: 'DimGray', fontWeight: 'bold' }}><i className="fas fa-tags" style={{ marginRight: '8px' }}></i>Thông tin gói dịch vụ</Label>
                        </CardHeader>

                        <CardBody>
                            <FormGroup>
                                <Label>Gói dịch vụ hiện tại: <strong>{selectedPackage ? selectedPackage.label : 'Chưa chọn'}</strong></Label>
                                <ul>
                                    <li>Thời hạn: {selectedPackage ? `${selectedPackage.exp} ngày` : ''}</li>
                                    <li>Giá tiền: {selectedVariation ? `${parseInt(selectedVariation.price).toLocaleString('vi-VN')} VNĐ` : ''}</li>
                                    <li>Số thiết bị: {drive}</li>
                                    <li>Ngày hết hạn: {moment(expired).format('DD/MM/YYYY')}</li>
                                </ul>

                                <div style={{ marginTop: "20px" }}>
                                    <Label>Thông tin thanh toán</Label>
                                    <div className="text-center">
                                        <p>Quét mã QR sau để thanh toán:</p>
                                        {paymentMethod === "Chuyển khoản" ? (
                                            <>
                                                <div className="qr-code-container" style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                    {orderId ? (
                                                        <>
                                                            <img
                                                                src={qrCodeUrl}
                                                                alt="QR Code thanh toán"
                                                                style={{ maxWidth: "100%", height: "auto" }}
                                                            />
                                                            <div className="mt-2 text-success">
                                                                <p><strong>ID đơn hàng:</strong> {orderId}</p>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <div className="placeholder" style={{
                                                            width: "100%",
                                                            height: "200px",
                                                            backgroundColor: "#f8f9fa",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            border: "1px dashed #ccc",
                                                            borderRadius: "4px"
                                                        }}>
                                                            <p className="text-muted">Mã QR sẽ được hiển thị sau khi tạo đơn hàng</p>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="bank-info" style={{ marginTop: "10px" }}>
                                                    <p><strong>Ngân hàng:</strong> Sacombank</p>
                                                    <p><strong>Số tài khoản:</strong> 050072093434</p>
                                                    <p><strong>Chủ tài khoản:</strong> ĐỖ HỮU BEN</p>
                                                    <p><strong>Nội dung:</strong> {orderId || '<ID đơn hàng sẽ hiển thị sau khi tạo>'}</p>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="alert alert-info">
                                                Bạn đã chọn phương thức thanh toán: <strong>{paymentMethod}</strong>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </FormGroup>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* Popup Modal Chọn Sản Phẩm */}
            <Modal isOpen={showProductModal} toggle={toggleProductModal} size="lg">
                <ModalHeader toggle={toggleProductModal}>
                    <Label style={{ fontSize: '20px', color: 'DimGray', fontWeight: 'bold', margin: 0 }}>Chọn sản phẩm</Label>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <div className="form-row mb-3">
                                    <div className="form-group col-md-4">
                                        <Label for="tool">Sản phẩm</Label>
                                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className="w-100">
                                            <DropdownToggle caret color="primary" className="w-100">
                                                {toolName}
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                {toolsList.map((tool, index) => (
                                                    <DropdownItem
                                                        key={index}
                                                        onClick={() => {
                                                            setSelectedTool(tool.id);
                                                            setToolName(tool.name);
                                                        }}
                                                    >
                                                        {tool.name}
                                                    </DropdownItem>
                                                ))}
                                            </DropdownMenu>
                                        </Dropdown>
                                    </div>
                                    <div className="form-group col-md-4">
                                        <Label for="package">Gói dịch vụ</Label>
                                        <Select
                                            className="dropdown-select"
                                            isSearchable={false}
                                            placeholder={selectedPackage}
                                            value={selectedPackage}
                                            onChange={(e) => {
                                                setSelectedPackage(e);
                                                setExpired(moment(new Date().addDays(e.exp)).format('YYYY-MM-DD'));

                                                // Tìm variation phù hợp với gói dịch vụ
                                                const matchingVariation = variations.find(variation => {
                                                    return variation.attributes.some(attr =>
                                                        attr.name.toLowerCase().includes('thời hạn') &&
                                                        attr.option.toLowerCase().includes(e.label.toLowerCase())
                                                    );
                                                });

                                                if (matchingVariation) {
                                                    setSelectedVariation(matchingVariation);
                                                    setPrice(matchingVariation.price || '300000');
                                                } else {
                                                    setPrice(e.price || '300000');
                                                }

                                                // Cập nhật số lượng thiết bị dựa trên gói dịch vụ
                                                if (e.value.includes("10")) {
                                                    setDrive(10);
                                                } else {
                                                    setDrive(1);
                                                }

                                                // Tìm và cập nhật thoiHan tương ứng
                                                const matchingThoiHan = optionsThoiHan.find(option => option.value === e.value);
                                                if (matchingThoiHan) {
                                                    setThoiHan(matchingThoiHan);
                                                }
                                            }}
                                            options={packages}
                                        />
                                    </div>
                                    {loai ? (
                                        <div className="form-group col-md-4">
                                            <Label for="loai">Loại</Label>
                                            <Select
                                                className="dropdown-select"
                                                isSearchable={false}
                                                placeholder={loai}
                                                value={loai}
                                                onChange={(e) => {
                                                    if (PATH == "dhbrender") {
                                                        if (e.value == "Dùng thử") {
                                                            setExpired(moment(new Date().addDays(7)).format('YYYY-MM-DD'))
                                                        } else {
                                                            setExpired(moment(new Date()).format('YYYY-MM-DD'))
                                                        }
                                                    }

                                                    setLoai(e)
                                                }}
                                                options={optionLoai}
                                            />
                                        </div>
                                    ) : <div className="form-group col-md-4"></div>}
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-md-4">
                                        <Label for="language">Ngôn ngữ</Label>
                                        <Select
                                            className="dropdown-select"
                                            isSearchable={false}
                                            placeholder={language}
                                            value={language}
                                            onChange={(e) => setLanguage(e.value)}
                                            options={optionsLanguage}
                                        />
                                    </div>
                                    <div className="form-group col-md-4">
                                        <Label for="drive">Số lượng thiết bị</Label>
                                        <Select
                                            className="dropdown-select"
                                            isSearchable={false}
                                            placeholder={drive}
                                            value={drive}
                                            onChange={(e) => setDrive(e.value)}
                                            options={optionsMaMay()}
                                        />
                                    </div>
                                    <div className="form-group col-md-4">
                                        <Label for="expired">Ngày hết hạn</Label>
                                        <Input
                                            disabled
                                            value={moment(expired).format('DD/MM/YYYY')}
                                            id="expired"
                                            style={{ backgroundColor: "#f8f9fa" }}
                                        />
                                        <small className="form-text text-muted">
                                            Tự động từ gói dịch vụ
                                        </small>
                                    </div>
                                </div>

                                <div className="form-row mt-3">
                                    <div className="form-group col-md-12">
                                        <Label for="price">Giá tiền</Label>
                                        <Input
                                            value={price}
                                            id="price"
                                            onChange={(e) => setPrice(e.target.value)}
                                            className="text-success font-weight-bold"
                                        />
                                        <small className="form-text text-muted">
                                            Giá từ biến thể sản phẩm
                                        </small>
                                    </div>
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button className='btn btn-secondary' onClick={toggleProductModal}>
                        Đóng
                    </Button>
                    <Button className='btn btn-success' onClick={() => {
                        addToCart();
                        toggleProductModal();
                    }}>
                        Thêm vào giỏ hàng <i className="nc-icon nc-cart-simple"></i>
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={modal} toggle={toggle} style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '90%'
            }}>
                <ModalHeader toggle={toggle}>
                    <Label style={{ fontSize: '24px', color: 'DimGray', fontWeight: 'bold' }}>Tạo đơn hàng thành công</Label>
                </ModalHeader>

                <ModalBody style={{ marginBottom: "20px" }}>
                    <div className="input-group" style={{ height: "38px", paddingTop: "0px", marginTop: "0px" }}>
                        <Input
                            style={{ height: "38px", marginTop: "10px" }}
                            value={email}
                        />
                        <div className="input-group-append">
                            <button className="btn btn-info" type="button" onClick={copyEmailToClipboard}>{
                                showCopyEmail
                                    ?
                                    <>
                                        Đã sao chép
                                    </>
                                    :
                                    <>
                                        Sao chép
                                    </>
                            }</button>
                        </div>
                    </div>
                    <textarea rows="50" style={style} className="form-control" value={message} />
                </ModalBody>

                <ModalFooter>
                    <Button onClick={copyToClipboard} className="btn btn-info" style={{ marginRight: "10px" }} >
                        {
                            showCopy
                                ?
                                <>
                                    Đã sao chép
                                </>
                                :
                                <>
                                    Sao chép
                                </>
                        }
                    </Button>
                    <Button onClick={() => {
                        toggle();
                        back();
                    }} className="btn btn-danger" >Đóng</Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default OrderCreate 